import React, { useContext, useEffect, useMemo, useState, useRef } from 'react';
import axios from 'axios';
import { Link, useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import '../../../assets/css/style.css';
import '../../../assets/css/bootstrap.css';
// import { FaFacebookF, FaSlash } from "react-icons/fa";
// import { FaLinkedinIn } from "react-icons/fa";
// import { FaInstagram } from "react-icons/fa";
// import { FaTwitter } from "react-icons/fa";
import MyProfileImage from './default.webp';
import { LoginContext } from '../../../context/LoginContext';
import { DONT_KNOW_GOTHRA_LABEL, isDontKnowGothra } from '../../../utils/gothra';
import { MessageContext } from '../../../context/MessageContext';
import MemberPhotoSlider from '../../common/MemberPhotoSlider';
import { getUserImages } from '../../../utils/userImages';
import VerificationBadges from '../../common/VerificationBadges';


const ProfilePage = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState(null);
  const [related, setRelated] = useState([]);
  const [age, setAge] = useState(21);
  const [ismypro, setisMyPro] = useState(false);
  const [loading, setLoading] = useState(true);
  const [realTimeViews, setRealTimeViews] = useState(0);
  const [displayViews, setDisplayViews] = useState(0);
  const relatedSwiperRef = useRef(null);
  const profileImages = useMemo(() => getUserImages(users), [users]);


  const [myHobbies, setmyHobbies] = useState([]);
  const { userData, userId, isLoggedIn, isPremium } = useContext(LoginContext);
  const { setMessageUserData, setMessageName, setMessageUserId, setIsMessage } = useContext(MessageContext)
  const param = useParams();



  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login");
      return;
    }

    const profileId = param.id;
    const invalidProfileId =
      !profileId ||
      profileId === 'null' ||
      profileId === 'undefined';

    if (invalidProfileId) {
      if (userId) {
        navigate(`/view-profile/${userId}`, { replace: true });
      } else {
        navigate("/login", { replace: true });
      }
      return;
    }

    const viewingOwnProfile = String(profileId) === String(userId);
    setisMyPro(viewingOwnProfile);
    setLoading(true);

    const payload = new FormData();
    payload.append("id", userId);
    payload.append("looking_for", userData.looking_for);
    payload.append("gender", userData.gender);
    payload.append("status", userData.status);
    payload.append("email", userData.email);
    payload.append("find_id", profileId);
    payload.append("limit", 30);

    axios.post(`${process.env.REACT_APP_API_BASE_URL}mycon/view_profile`, payload)
      .then(response => {
        if (response.data?.response === 'limit' || response.data?.response === 'upgrade') {
          alert(response.data.message || 'Unable to view this profile');
          if (response.data.response === 'upgrade') {
            navigate(`/upgrade/${userId}`);
          } else {
            navigate('/recently-joined-matches');
          }
          setUsers(null);
          return;
        }
        const details = response.data?.details;
        if (!details) {
          setUsers(null);
          return;
        }
        setUsers(details);
        const views = Number(details.visitor) || 0;
        setRealTimeViews(views);
        setDisplayViews(views);
        if (details.dob) {
          setAge(calculateAge(details.dob));
        }
        if (details.hobbies != null) {
          const hobbyStr = Array.isArray(details.hobbies)
            ? details.hobbies.join(',')
            : String(details.hobbies);
          setmyHobbies(hobbyStr ? hobbyStr.split(',').map((h) => h.trim()).filter(Boolean) : []);
        }
      })
      .catch(error => {
        console.error("There was an error fetching users!", error);
        setUsers(null);
      })
      .finally(() => setLoading(false));

    if (!viewingOwnProfile) {
      axios.post(`${process.env.REACT_APP_API_BASE_URL}mycon/desire_patner_match`, payload)
        .then(response => {
          const matched = response.data?.matched || [];
          setRelated(matched.filter(user => String(user.user_id) !== String(profileId)));
        })
        .catch(error => {
          console.error("There was an error fetching users!", error);
        });
    } else {
      setRelated([]);
    }

  }, [param.id, isLoggedIn, userId, userData, navigate]);

  // Poll live view count while profile page is open
  useEffect(() => {
    const profileId = param.id;
    if (!isLoggedIn || !profileId || profileId === 'null' || profileId === 'undefined') {
      return undefined;
    }

    const fetchLiveViews = () => {
      const fd = new FormData();
      fd.append('find_id', profileId);
      axios
        .post(`${process.env.REACT_APP_API_BASE_URL}mycon/profile_visitor_count`, fd)
        .then((res) => {
          if (res.data?.response === 'success') {
            const next = Number(res.data.visitor) || 0;
            setRealTimeViews(next);
            setUsers((prev) => (prev ? { ...prev, visitor: next } : prev));
          }
        })
        .catch(() => {});
    };

    fetchLiveViews();
    const intervalId = setInterval(fetchLiveViews, 12000);
    return () => clearInterval(intervalId);
  }, [param.id, isLoggedIn]);

  // Animate count when views increase
  useEffect(() => {
    if (displayViews === realTimeViews) {
      return undefined;
    }
    if (realTimeViews < displayViews) {
      setDisplayViews(realTimeViews);
      return undefined;
    }
    const tick = setInterval(() => {
      setDisplayViews((current) => {
        if (current >= realTimeViews) {
          clearInterval(tick);
          return realTimeViews;
        }
        return current + 1;
      });
    }, 60);
    return () => clearInterval(tick);
  }, [realTimeViews, displayViews]);

  // Function to calculate age from DOB
  const calculateAge = (dob) => {
    if (!dob) return 'N/A';
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  // Function to format height (assuming height is stored as "feet.inches" like "5.6")
  const formatHeight = (height) => {
    if (!height) return 'N/A';
    const parts = height.split('.');
    if (parts.length === 2) {
      return `${parts[0]}'${parts[1]}"`;
    }
    return height;
  };


  const handleMessage = () => {
    if (!users) return;
    if (!isPremium) {
      navigate(`/upgrade/${userId}`);
      return;
    }
    setMessageUserData(users);
    setMessageName(users.name);
    setMessageUserId(users.user_id);
    setIsMessage(true);
    navigate(`/chat/${param.id}`);
  }

  if (loading) {
    return (
      <div className="container py-5 text-center">
        <p>Loading profile...</p>
      </div>
    );
  }

  if (!users) {
    return (
      <div className="container py-5 text-center">
        <p>Profile not found.</p>
        <Link to="/recently-joined-matches">Back to matches</Link>
      </div>
    );
  }

  return (
    <>

      <section className="view-profile-page">
        <style>
          {`

.view-profile-page {
  width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

.pg-pro-big-im .s1 {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.pg-pro-big-im .profile-main-photo {
  width: 100%;
  aspect-ratio: 4 / 5;
  max-height: 520px;
  min-height: 0;
  overflow: hidden;
  background: #ececec;
  position: relative;
  line-height: 0;
}
.pg-pro-big-im .profile-main-photo__img {
  width: 100% !important;
  height: 100% !important;
  max-width: none !important;
  max-height: none !important;
  object-fit: cover !important;
  object-position: center center !important;
  display: block !important;
  margin: 0 !important;
}

.view-profile-page .profile-cta-btn {
  font-size: 18px;
  min-height: 48px;
  width: 100%;
}

.view-profile-page .pro-info-status {
  display: flex !important;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  max-width: 100%;
  width: 100%;
  margin: 12px 0 20px 0 !important;
  float: none !important;
  position: relative;
  z-index: 2;
}

.view-profile-page .pro-info-status .hs-vsimple,
.view-profile-page .pro-info-status .pro-verify-inline {
  width: auto !important;
  flex: 0 0 auto !important;
  display: inline-flex !important;
  justify-content: center !important;
  margin: 0 !important;
}

.view-profile-page .pro-info-status .btn,
.view-profile-page .pro-info-status .stat-1,
.view-profile-page .pro-info-status .stat-2,
.view-profile-page .pro-info-status a {
  margin: 0 !important;
  float: none !important;
  position: static !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  flex: 0 1 auto;
  white-space: nowrap;
  line-height: 1.3;
  text-decoration: none;
  border-radius: 6px;
  font-size: 15px !important;
  padding: 8px 14px !important;
  color: #fff !important;
}

.view-profile-page .pro-info-status .stat-1 {
  background: #f6af04 !important;
}

.view-profile-page .pro-info-status .stat-2 {
  background: rgb(91, 188, 113) !important;
}

.view-profile-page .pro-info-status a.btn-danger,
.view-profile-page .pro-info-status .btn-danger {
  background: #E53D5C !important;
  border-color: #E53D5C !important;
}

@media (min-width: 992px) {
  .view-profile-page .pro-info-status {
    justify-content: flex-start;
  }

  .view-profile-page .pro-pg-intro h1 {
    text-align: left;
    padding-top: 0;
  }
}

.view-profile-page .pro-pg-intro ul {
  list-style: none;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  width: 100%;
  margin: 0 0 24px 0;
  float: none;
}

.view-profile-page .pro-pg-intro ul li {
  float: none !important;
  width: 100%;
  margin: 0 !important;
}

.view-profile-page .pro-pg-intro ul li div {
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
}

.view-profile-page .pr-bio-c {
  padding-left: 4px;
  padding-right: 4px;
}

        .view-profile-page .related-profiles-wrap {
          width: 100%;
          max-width: 100%;
          padding: 0 6px;
          box-sizing: border-box;
        }

        .view-profile-page .wedd-rel-pro {
          padding-left: 8px !important;
          padding-right: 8px !important;
        }

        .view-profile-page .related-profiles-swiper {
          position: relative;
          padding: 0;
          width: 100%;
        }

        .view-profile-page .related-nav-row {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 56px;
          margin-top: 16px;
          padding: 4px 0 12px;
        }

        .view-profile-page .related-nav-btn {
          position: static;
          transform: none;
          flex-shrink: 0;
          width: 44px;
          height: 44px;
          border-radius: 50%;
          border: 1px solid #e53d5c;
          background: #fff;
          color: #e53d5c;
          font-size: 26px;
          line-height: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          transition: background 0.2s, color 0.2s;
        }

        .view-profile-page .related-nav-btn:hover:not(:disabled) {
          background: #e53d5c;
          color: #fff;
        }

        .view-profile-page .related-nav-btn:disabled {
          opacity: 0.35;
          cursor: not-allowed;
        }

        .view-profile-page .related-profiles-swiper .swiper-slide {
          height: auto;
        }

        .view-profile-page .related-profiles-swiper .member-card {
          height: 100%;
          width: 100%;
        }

        .view-profile-page .related-profiles-swiper .member-photo {
          aspect-ratio: 3 / 4;
          min-height: 0;
          max-height: none;
        }

        .view-profile-page .related-profiles-swiper .member-info {
          padding: 10px 8px 12px;
        }

        .view-profile-page .related-profiles-swiper .member-details {
          font-size: 12px;
        }

        .view-profile-page .pr-bio-info ul li {
          word-break: break-word;
          line-height: 1.45;
          margin-bottom: 0.5rem;
        }
       .menu-pop-soci ul li link i {
            width: 38px;
    height: 38px;
    background: rgb(247, 247, 247);
    text-align: center;
    display: inline-block;
    border-radius: 5px;
    color: rgb(51, 51, 51);
    font-size: 18px;
    padding: 11px 8px;
    transition: all 0.5s ease;
}
         .member-info h5, .member-id{
            color: white !important;
            text-align: center;
    }
      .detail-label{
            color: white !important;
      }
      .detail-value{
            color: white !important;
      }
        .recently-joined-container {
          padding: 60px 20px;
          background: #fff;
        }
          .swiper-container {
          padding: 0px;
          position: relative;
          margin-bottom: 30px;
        }
        .member-card {
          width: 100%;
          max-width: 100%;
          margin: 0 auto;
          background: white;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease;
        }
        .member-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
        }
        .member-photo {
          width: 100%;
          aspect-ratio: 3 / 4;
          height: auto;
          min-height: 240px;
          max-height: 300px;
          overflow: hidden;
          background: #f0f0f0;
          position: relative;
        }
        .member-image {
          width: 100% !important;
          height: 100% !important;
          max-width: none !important;
          object-fit: cover !important;
          object-position: center center !important;
          display: block !important;
        }
        .member-info {
          background: #E53D5C;
          color: white;
          padding: 15px;
        }
        .member-id-gender {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          justify-content: center;
        }
        .gender-badge {
          background: white;
          color: #E53D5C;
          border-radius: 3px;
          padding: 2px 5px;
          font-weight: bold;
          margin-right: 8px;
        }
        .member-id {
          font-weight: bold;
          font-size: 14px;
        }
        .member-details {
          font-size: 13px;
        }
        .detail-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 5px;
          padding-bottom: 5px;
          border-bottom: 1px solid rgba(255,255,255,0.1);
        }
        .detail-row:last-child {
          border-bottom: none;
          margin-bottom: 0;
          padding-bottom: 0;
        }
        .detail-label {
          font-weight: 500;
        }
        .detail-value {
          text-align: right;
        }.swiper-button-next, .swiper-button-prev {
          color: #E53D5C;
          width: 40px;
          height: 40px;
          background: white;
          border-radius: 50%;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          transition: all 0.3s ease;
        }
        .swiper-button-next:hover, .swiper-button-prev:hover {
          background: #E53D5C;
          color: white;
        }
        .swiper-button-next:after, .swiper-button-prev:after {
          font-size: 18px;
          font-weight: bold;
        }
        .swiper-pagination-bullet {
          background: #ccc;
          opacity: 1;
          width: 12px;
          height: 12px;
        }
        .swiper-pagination-bullet-active {
          background: #E53D5C;
        }
          .menu-pop-soci ul li  i {
    width: 38px;
    height: 38px;
    background: rgb(247, 247, 247);
    text-align: center;
    display: inline-block;
    border-radius: 5px;
    color: rgb(51, 51, 51);
    font-size: 18px;
    padding: 11px 8px;
    transition: all 0.5s ease;
}
        @media (max-width: 768px) {
          .view-profile-page .profi-ban {
            margin-top: 0.75rem !important;
          }

          .view-profile-page .profi-ban .container,
          .view-profile-page .profi-ban .container-fluid,
          .view-profile-page .profi-ban .container-lg {
            padding-left: 12px;
            padding-right: 12px;
            max-width: 100%;
          }

          .view-profile-page .pg-pro-big-im .profile-main-photo {
            max-width: 100%;
            max-height: min(62vh, 440px);
            margin: 0 auto;
          }

          .view-profile-page .pro-pg-intro h1 {
            font-size: 1.35rem !important;
            line-height: 1.35;
            text-align: center;
            padding: 12px 8px 0;
            word-break: break-word;
          }

          .view-profile-page .pro-info-status {
            justify-content: center;
          }

          .view-profile-page .pro-info-status .btn,
          .view-profile-page .pro-info-status .stat-1,
          .view-profile-page .pro-info-status .stat-2,
          .view-profile-page .pro-info-status a {
            font-size: 13px !important;
            padding: 8px 12px !important;
            flex: 1 1 calc(50% - 8px);
            min-width: 130px;
            white-space: normal;
            line-height: 1.25;
          }

          .view-profile-page .pro-pg-intro ul {
            display: grid !important;
            grid-template-columns: 1fr 1fr;
            gap: 10px;
            width: 100% !important;
            margin: 0 auto 24px !important;
            float: none;
          }

          .view-profile-page .pro-pg-intro ul li {
            float: none !important;
            width: 100%;
            margin: 0 !important;
          }

          .view-profile-page .pro-pg-intro ul li div {
            min-width: 0;
            width: 100%;
            padding: 12px 8px;
          }

          .view-profile-page .pro-pg-intro ul li div span {
            font-size: 13px;
          }

          .view-profile-page .pro-pg-intro ul li div span strong {
            font-size: 15px;
          }

          .view-profile-page .pr-bio-c h3,
          .view-profile-page h3.text-center {
            font-size: 1.25rem;
          }

          .view-profile-page .pr-bio-abo p {
            font-size: 15px;
            line-height: 1.55;
            padding: 0 4px;
          }

          .view-profile-page .col-md-12.py-2,
          .view-profile-page .col-md-4 {
            padding-left: 12px;
            padding-right: 12px;
          }

          .view-profile-page .pro-gal-imag {
            width: 100%;
            margin-bottom: 12px;
          }

          .view-profile-page .pro-gal-imag img {
            width: 100%;
            height: auto;
            object-fit: cover;
            max-height: 280px;
          }

          .view-profile-page .related-profiles-section {
            padding-left: 6px !important;
            padding-right: 6px !important;
          }

          .view-profile-page .related-profiles-wrap {
            padding: 0 4px;
          }

          .view-profile-page .related-profiles-swiper {
            padding: 0;
          }

          .view-profile-page .related-profiles-swiper .member-details {
            font-size: 12px;
          }

          .view-profile-page .related-profiles-swiper .member-info h5 {
            font-size: 1rem;
          }

          .view-profile-page .related-nav-row {
            gap: 40px;
            margin-top: 12px;
          }

          .view-profile-page .related-nav-btn {
            width: 42px;
            height: 42px;
            font-size: 24px;
          }

          .swiper-container {
            padding: 0;
            margin-bottom: 0;
          }
        }

        @media (max-width: 480px) {
          .view-profile-page .pro-pg-intro ul {
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 8px;
          }
          .view-profile-page .pro-pg-intro ul li div {
            padding: 10px 6px;
          }
          .recently-joined-container {
            padding: 40px 15px;
          }
          .member-details {
            font-size: 12px;
          }`}
        </style>
        <div class="profi-ban mt-5 mt-md-5">
          <div class="container-fluid container-lg">
            <div class="row justify-content-center g-3">
              <div class="profile col-12 col-lg-4 col-xl-4">
                <div class="pg-pro-big-im">
                  <div class="s1">
                    <div className="profile-main-photo">
                      <MemberPhotoSlider
                        images={profileImages}
                        alt={users.name || 'Profile'}
                        className="member-photo-slider--lg"
                        imageClassName="profile-main-photo__img"
                      />
                    </div>

                    {(!ismypro) &&
                      <span onClick={handleMessage} className="btn rounded-0 btn-lg text-white d-block py-3 profile-cta-btn" style={{ background: "#E53D5C" }}><b>Message</b> Now</span>}

                    {(ismypro) && <>
                      <Link to={`/profile-picture/${userId}`} className="btn rounded-0 btn-lg text-white d-block py-3 profile-cta-btn" style={{ background: "#E53D5C" }}>Add Photos</Link>
                    </>
                    }
                  </div>
                  {/* <div class="">
                                <a href="#!" class="cta fol cta-chat">Message Now</a>
                            </div> */}
                </div>
              </div>
              <div class="col-12 col-lg-8 col-xl-8">
                <div class="lhs">
                  <div class="pro-pg-intro">
                    <h1 className='mb-0' style={{ textTransform: "capitalize" }}>{(users.name) ?? "Hi Guest"} <span style={{ color: "#E53D5C" }}> (HS{users.user_id})</span></h1>
                    <div className="pro-info-status mb-3">
                      <span className="stat-1 btn px-3 py-1">
                        <b>{displayViews}</b>&nbsp;Real Time Views
                      </span>

                      {!ismypro && (
                        <span className="stat-2 btn px-3 py-1">
                          <b>Recently</b>&nbsp;online
                        </span>
                      )}
                      {ismypro && (
                        <Link
                          to={`/edit-profile/${userId}`}
                          className="btn btn-danger px-3 py-1"
                        >
                          <b>Edit</b>&nbsp;Profile
                        </Link>
                      )}
                      <VerificationBadges
                        verifyMobile={users.verify_mobile}
                        verifyEmail={users.verify_email}
                        className="pro-verify-inline"
                      />
                    </div>
                    <ul className='mb-3'>
                      <li>
                        <div>
                          <img src="images/icon/pro-city.png" loading="lazy" alt="" />
                          <span>City: <strong>{users.curr_location ?? "India"}</strong></span>
                        </div>
                      </li>
                      <li>
                        <div>
                          <img src="images/icon/pro-age.png" loading="lazy" alt="" />
                          <span>Age: <strong>{(users.age)?users.age:"Not Filled"}</strong></span>
                        </div>
                      </li>
                      <li>
                        <div>
                          <img src="images/icon/pro-city.png" loading="lazy" alt="" />
                          <span>Height: <strong>{(users.height)?users.height:"Not Filled"} Ft</strong></span>
                        </div>
                      </li>
                      <li>
                        <div>
                          <img src="images/icon/pro-city.png" loading="lazy" alt="" />
                          <span>Profession: <strong>{(users.occupation)?users.occupation:"Not Filled"}</strong></span>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div class="pr-bio-c pr-bio-abo">
                    <h3 style={{ color: "#E53D5C" }}>About</h3>
                    <p>{(users.desc)?users.desc:"Not"}</p>
                  </div>






                </div>
              </div>


              <div class="col-md-12 py-2">

                {profileImages.length > 1 && <div class="pr-bio-c pr-bio-gal" id="gallery">
                  <h3 style={{ color: "#E53D5C" }}>Photo gallery</h3>
                  <div id="image-gallery">

                    {profileImages.map((imageUrl, index) => (
                      <div className="pro-gal-imag" key={imageUrl}>
                        <div className="img-wrapper position-relative">
                          <img
                            src={imageUrl}
                            loading="lazy"
                            className="img-responsive rounded-0"
                            alt={`${users.name || 'Profile'} ${index + 1}`}
                            onError={(e) => {
                              e.target.src = MyProfileImage;
                              e.target.onerror = null;
                            }}
                          />
                        </div>
                      </div>
                    ))}





                  </div>
                </div>}

              </div>

              <div class="col-md-12 py-2">

                <h3 className='text-center fw-bold'>Profile <span style={{ color: "#E53D5C" }}>information</span> </h3>
                <div class="pr-bio-c pr-bio-info">
                  <div className='row g-3'>
                    <div className='col-12 col-md-4' >
                      <ul>
                        <li><b>Name:</b> {(users.name != "") ? (users.name) : "Not Filled"} <span style={{ color: "#E53D5C" }}> (HS{users.user_id})</span></li>
                        <li><b>Date of birth:</b>{(users.dob != "") ? (users.dob) : ("Not Filled")}</li>
                        <li><b>Religion:</b> {(users.religion != "") ? (users.religion) : "Not Filled"}</li>
                        <li><b>Caste:</b> {(users.caste != "") ? (users.caste) : "Not Filled"}</li>
                        <li><b>Current Location:</b> {(users.curr_location != "") ? (users.curr_location) : "Not Filled"}</li>
                       
                      </ul>

                    </div>
                    <div className='col-12 col-md-4' >
                      <ul>

                        <li><b>Mother Tounge:</b> {(users.language != "") ? (users.language) : "Not Filled"}</li>
                        <li><b>Marital Status:</b> {(users.marital_status != "") ? (users.marital_status) : "Not Filled"}</li>


                        <li><b>Age:</b> {(age != "") ? (age + " Years") : ("Not Filled")}</li>
                        <li><b>Height:</b>{(users.height != "") ? (users.height + " Ft") : "Not Filled"}</li>
                        <li><b>Weight:</b>{(users.weight != "") ? (users.weight + " Kg") : "Not Filled"}</li>
                      </ul>

                    </div>
                    <div className='col-12 col-md-4' >
                      <ul>
                        <li><b>Body Type:</b>{(users.bdy_type != "") ? (users.bdy_type) : "Not Filled"}</li>
                        <li><b>Physical Status:</b>{(users.ps != "") ? (users.ps) : "Not Filled"}</li>

                        <li><b>Eating Habits:</b>{(users.eating != "") ? (users.eating) : "Not Filled"}</li>
                        <li><b>Drinking Habits:</b>{(users.drinking != "") ? (users.drinking) : "Not Filled"}</li>
                        <li><b>Smoking Habits:</b>{(users.smoking != "") ? (users.smoking) : "Not Filled"}</li>
                      </ul>

                    </div>
                  </div>
            {/* <ul>
                    <li><b>Name:</b> {(users.name != "") ? (users.name) : "Not Filled"} <span style={{ color: "#E53D5C" }}> (HS{users.user_id})</span></li>
                    <li><b>Date of birth:</b>{(users.dob != "") ? (users.dob) : ("Not Filled")}</li>
                    <li><b>Religion:</b> {(users.religion != "") ? (users.religion) : "Not Filled"}</li>
                    <li><b>Caste:</b> {(users.caste != "") ? (users.caste) : "Not Filled"}</li>
                    <li><b>Current Location:</b> {(users.curr_location != "") ? (users.curr_location) : "Not Filled"}</li>
                    <li><b>Mother Tounge:</b> {(users.language != "") ? (users.language) : "Not Filled"}</li>
                    <li><b>Marital Status:</b> {(users.marital_status != "") ? (users.marital_status) : "Not Filled"}</li>


                    <li><b>Age:</b> {(age != "") ? (age + " Years") : ("Not Filled")}</li>
                    <li><b>Height:</b>{(users.height != "") ? (users.height + " Ft") : "Not Filled"}</li>
                    <li><b>Weight:</b>{(users.weight != "") ? (users.weight + " Kg") : "Not Filled"}</li>

                    <li><b>Body Type:</b>{(users.bdy_type != "") ? (users.bdy_type) : "Not Filled"}</li>
                    <li><b>Physical Status:</b>{(users.ps != "") ? (users.ps) : "Not Filled"}</li>

                    <li><b>Eating Habits:</b>{(users.eating != "") ? (users.eating) : "Not Filled"}</li>
                    <li><b>Drinking Habits:</b>{(users.drinking != "") ? (users.drinking) : "Not Filled"}</li>
                    <li><b>Smoking Habits:</b>{(users.smoking != "") ? (users.smoking) : "Not Filled"}</li>
                  </ul> */}

                </div>
              </div>




              <div class="col-12 col-md-6 col-lg-4">

                <div class="pr-bio-c pr-bio-info">
                  <h3 className='text-center'>Education <span style={{ color: "#E53D5C" }}>Career</span> </h3>
                  <ul>
                    <li><b>Highest Education:</b> {(users.highest_edu != "") ? (users.highest_edu) : ("Not Filled")}</li>
                    <li><b>Edu Qual:</b> {(users.ug_degree != "") ? (users.ug_degree) : ("Not Filled")}</li>
                    <li><b>Profession:</b> {(users.occupation != "") ? (users.occupation) : ("Not Filled")}</li>
                    <li><b>Position:</b> {(users.emp_in != "") ? (users.emp_in) : ("Not Filled")}</li>
                    <li><b>Annual Income:</b>{(users.income != "") ? (users.income) : ("Not Filled")}</li>
                    <li><b>Company:</b> {(users.org_name != '') ? (users.org_name) : ("Not Filled")}</li>
                  </ul>
                </div>

              </div>
              <div class="col-12 col-md-6 col-lg-4">


                <div class="pr-bio-c pr-bio-info">
                  <h3 className='text-center'>Family <span style={{ color: "#E53D5C" }}>Details</span> </h3>
                  <ul>
                    <li><b>Family Type:</b> {users.family_type != "" ? users.family_type : "Not Filled"}</li>
                    <li><b>Native State:</b> {users.family_based != "" ? users.family_based : "Not Filled"}</li>
                    <li><b>Brother:</b> {(users.brother != "") ? (users.brother) : ("Not Filled")}</li>
                    <li><b>sister:</b> {(users.sister != "") ? (users.sister) : ("Not Filled")}</li>
                    <li><b>Gothra:</b> {users.gothraname ? users.gothraname : (isDontKnowGothra(users.gothra) ? DONT_KNOW_GOTHRA_LABEL : "Not Filled")}</li>
                    <li><b>Maternal Gothra:</b> {users.gothramaternalname ? users.gothramaternalname : (isDontKnowGothra(users.gothra_maternal) ? DONT_KNOW_GOTHRA_LABEL : "Not Filled")}</li>
                  </ul>
                </div>

              </div>
              <div class="col-12 col-md-6 col-lg-4">


                <div class="pr-bio-c pr-bio-info">
                  <h3 className='text-center'>Contact <span style={{ color: "#E53D5C" }}>Details</span> </h3>
                  <ul>
                    <li><b>Living with Parent:</b> {(users.living_wth_parents != "") ? (users.living_wth_parents) : ("Not Filled")}</li>
                    <li><b>Country:</b> {(users.country != "") ? (users.country) : ("Not Filled")}</li>
                    <li><b>State:</b> {(users.state != "") ? (users.state) : ("Not Filled")}</li>
                    <li><b>City:</b> {(users.city != "") ? (users.city) : ("Not Filled")}</li>
                    <li><b>Pincode:</b> {(users.pin != "") ? (users.pin) : ("Not Filled")}</li>
                  </ul>
                </div>

              </div>

              <div class="col-md-12">

                {users.hobbies && <div class="pr-bio-c pr-bio-hob">
                  <h3 style={{ color: "#E53D5C" }}>Hobbies</h3>
                  <ul>
                    {myHobbies.map(res => (
                      <li><span style={{ textTransform: "capitalize" }}>{res}</span></li>
                    ))}
                  </ul>
                </div>}

                {/* <div class="pr-bio-c menu-pop-soci pr-bio-soc">
                    <h3 style={{ color: "#E53D5C" }}>Social media</h3>
                    <ul>
                      <li><i> <FaFacebookF /></i></li>
                      <li><i><FaLinkedinIn /></i></li>
                      <li><i><FaInstagram /></i></li>
                      <li><i><FaTwitter /></i></li>
                    </ul>
                  </div> */}
              </div>


              {(!ismypro) &&
                <div class="col-md-12 related-profiles-section" >
                  <div class="rhs">

                    <div class="slid-inn pr-bio-c wedd-rel-pro">
                      <h3 className='fs-3'>Related <span style={{ color: "#E53D5C" }}>profiles</span> </h3>
                      <div className="related-profiles-wrap">
                        <div className="swiper-container related-profiles-swiper">
                        <Swiper
                          modules={[Navigation, Pagination, Autoplay]}
                          onSwiper={(swiper) => { relatedSwiperRef.current = swiper; }}
                          spaceBetween={8}
                          slidesPerView={2}
                          slidesPerGroup={2}
                          navigation={false}
                          autoplay={{
                            delay: 4000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                          }}
                          loop={related.length > 2}
                          breakpoints={{
                            0: {
                              slidesPerView: 2,
                              slidesPerGroup: 2,
                              spaceBetween: 6,
                            },
                            768: {
                              slidesPerView: 3,
                              slidesPerGroup: 3,
                              spaceBetween: 12,
                            },
                            1024: {
                              slidesPerView: 4,
                              slidesPerGroup: 4,
                              spaceBetween: 16,
                            },
                          }}
                        >

                          {/* onClick={() => navigate(`/profile/${member.user_id}`)} */}

                          {related.slice(0, 30).map((member, index) => (
                            <SwiperSlide key={index}>
                              <Link style={{ color: "white" }}   to={isPremium?`/view-profile/${member.user_id}`:`/upgrade/${userId}`} >
                              <div className="member-card"
                                style={{ cursor: "pointer" }}>
                                <div className="member-photo">
                                  <MemberPhotoSlider
                                    images={getUserImages(member)}
                                    alt={member.name}
                                    imageClassName="member-image"
                                    nested
                                  />
                                </div>

                                <div className="member-info">
                                  <h5>{member.name}</h5>
                                  <div className="member-id-gender">
                                    <span className="member-id">
                                      {member.gender === 'male' ? 'M' : member.gender === 'female' ? 'F' : ''}
                                    </span>
                                    <span className="member-id">HS{member.user_id}</span>
                                  </div>
                                  <VerificationBadges
                                    compact
                                    verifyMobile={member.verify_mobile}
                                    verifyEmail={member.verify_email}
                                  />

                                  <div className="member-details">
                                    <div className="detail-row">
                                      <span className="detail-label">Age:</span>
                                      <span className="detail-value">{calculateAge(member.dob)} Yrs</span>
                                    </div>
                                    <div className="detail-row">
                                      <span className="detail-label">Height:</span>
                                      <span className="detail-value">{formatHeight(member.height)}</span>
                                    </div>
                                    <div className="detail-row">
                                      <span className="detail-label">Gender:</span>
                                      <span className="detail-value">
                                        {member.gender === 'male' ? 'Male' : member.gender === 'female' ? 'Female' : 'N/A'}
                                      </span>
                                    </div>
                                    <div className="detail-row">
                                      <span className="detail-label">Caste:</span>
                                      <span className="detail-value">{member.caste || 'N/A'}</span>
                                    </div>
                                    <div className="detail-row">
                                      <span className="detail-label">Location:</span>
                                      <span className="detail-value">{member.curr_location || member.country || 'India'}</span>
                                    </div>
                                  </div>
                                </div>
                              </div></Link>
                            </SwiperSlide>
                          ))}
                        </Swiper>
                        </div>
                        <div className="related-nav-row">
                          <button
                            type="button"
                            className="related-nav-btn related-nav-prev"
                            aria-label="Previous profiles"
                            onClick={() => relatedSwiperRef.current?.slidePrev()}
                          >
                            ‹
                          </button>
                          <button
                            type="button"
                            className="related-nav-btn related-nav-next"
                            aria-label="Next profiles"
                            onClick={() => relatedSwiperRef.current?.slideNext()}
                          >
                            ›
                          </button>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>}


            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProfilePage;
